import { ApiResponse } from 'apisauce'

import * as T from 'types'

export const getDataFromResponse = <A>(
  response: ApiResponse<A | T.IHttpServerError, any>,
): A | undefined => (response.ok ? (response.data as A) : undefined)
